const THREE = require('three')
import {TweenMax, TimelineMax, Cubic} from 'gsap'
import raf from '../raf'

//
// INIT
//

// GEOMETRY
let geometry = new THREE.PlaneBufferGeometry( 120, 120, 1 )

// MATERIAL
let canvas = document.createElement('canvas')
canvas.width = 512
canvas.height = 512
let ctx = canvas.getContext('2d')
let texture = new THREE.Texture(canvas)
let material = new THREE.MeshBasicMaterial({
  map: texture,
  transparent: true
})
material.depthTest = false
material.depthWrite = false

// MESH
export let mesh = new THREE.Mesh( geometry, material )
mesh.name = 'cta'
mesh.scale.setScalar(1)

// ANIMATION
let timeline


//
// Drawing
//
export let draw = function (string) {
  return new Promise((resolve)=> {
    reset()
    drawCanvas(string)
    // animateMesh()
    texture.needsUpdate = true
  })
}


//
// CANVAS
//
export const drawCanvas = function(string) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  // get dimensions text
  let fontSize = (30 * 14) / string.length
  ctx.font = `${fontSize}px cjnbold`
  const textWidth = ctx.measureText(string).width

  // trapezoid rectangle background
  let x = 0 // starting
  let y = 100 // starting
  let a = 0 // angle
  let w = textWidth + 40 // width
  let h = fontSize + 20 // height
  let center = (ctx.canvas.width / 2) - (w / 2) // centering

  ctx.fillStyle = '#FF0000'
  ctx.beginPath()
  // ctx.moveTo(w, h)
  // ctx.lineTo(2 * w, h)
  // ctx.lineTo(2 * w - a, 0)
  // ctx.lineTo(w - a, 0)
  ctx.moveTo(center + a + x, y)
  ctx.lineTo(center + w + a + x, y)
  ctx.lineTo(center + w + x, h + y)
  ctx.lineTo(center + x, h + y)
  ctx.fill()

  // text
  ctx.fillStyle = '#FFFFFF'
  ctx.fillText(string, center + a + x + 15, h - 23 + y)

}

//
// ANIMATIONS
//
export const animateMesh = function(duration) {
  texture.offset.x = -50

  timeline = new TimelineMax()
  if (duration) timeline.duration(duration)
  timeline.to(texture.offset, 1, {x: 0, ease: Cubic.easeInOut})
  timeline.to(texture.offset, 1, {x: 50, ease: Cubic.easeInOut}, '+=3')
  timeline.play()
}

export const animIn = function(duration = 1) {
  texture.offset.x = -50
  TweenMax.to(texture.offset, duration, {x: 0, ease: Cubic.easeOut})
}

export const animOut = function(duration = 1) {
  TweenMax.to(texture.offset, duration, {x: 50, ease: Cubic.easeOut})
}

// RESET
export const reset = function() {
  if (timeline) {
    timeline.pause(0, true)
    timeline.remove()
  }

  let ctx = canvas.getContext('2d')
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
}





// WEBPACK FOOTER //
// ./src/components/game/ui/cta.js